import React from 'react';
import { TrendingUpIcon, ShieldIcon, WrenchIcon, AwardIcon } from 'lucide-react';
import { useTranslation } from '../../lib/i18n';
export function WhyDTech() {
  const {
    lang
  } = useTranslation();
  const reasons = lang === 'en' ? [{
    icon: TrendingUpIcon,
    title: 'Proven ROI',
    description: 'Reduce labor costs and improve productivity. Our equipment pays for itself through increased efficiency and reduced workplace injuries.'
  }, {
    icon: ShieldIcon,
    title: 'Safety focus',
    description: 'Minimize manual handling risks. Designed with safety features that protect your team and reduce liability.'
  }, {
    icon: WrenchIcon,
    title: 'Easy maintenance',
    description: 'Simple, straightforward maintenance procedures. Minimal downtime means maximum productivity for your operation.'
  }, {
    icon: AwardIcon,
    title: 'Quality guarantee',
    description: 'Comprehensive warranty and quality assurance. We stand behind every unit with expert technical support.'
  }] : [{
    icon: TrendingUpIcon,
    title: 'Dokazani povraćaj investicije',
    description: 'Smanjite troškove rada i poboljšajte produktivnost. Naša oprema se isplaćuje kroz povećanu efikasnost i smanjene povrede na radnom mestu.'
  }, {
    icon: ShieldIcon,
    title: 'Fokus na bezbednost',
    description: 'Minimizirajte rizike od ručnog prenošenja. Dizajnirano sa sigurnosnim funkcijama koje štite vaš tim i smanjuju odgovornost.'
  }, {
    icon: WrenchIcon,
    title: 'Lako održavanje',
    description: 'Jednostavne, direktne procedure održavanja. Minimalno vreme zastoja znači maksimalnu produktivnost za vašu operaciju.'
  }, {
    icon: AwardIcon,
    title: 'Garancija kvaliteta',
    description: 'Sveobuhvatna garancija i osiguranje kvaliteta. Stojimo iza svake jedinice sa stručnom tehničkom podrškom.'
  }];
  return <section className="py-20 bg-dark-surface" data-id="element-279">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-280">
        <div className="text-center mb-12" data-id="element-281">
          <h2 className="text-4xl md:text-5xl font-black text-white mb-4" data-id="element-282">
            {lang === 'en' ? <>
                Why choose <span className="text-brand-yellow" data-id="element-283">D-TECH</span>
              </> : <>
                Zašto izabrati <span className="text-brand-yellow" data-id="element-284">D-TECH</span>
              </>}
          </h2>
          <p className="text-xl text-gray-400 max-w-3xl mx-auto" data-id="element-285">
            {lang === 'en' ? 'Investing in the right equipment drives business success. Here is why professionals choose D-TECH Solutions.' : 'Investicija u pravu opremu pokreće poslovni uspeh. Evo zašto profesionalci biraju D-TECH Solutions.'}
          </p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8" data-id="element-286">
          {reasons.map(reason => {
          const Icon = reason.icon;
          return <div key={reason.title} className="text-center" data-id="element-287">
                <div className="w-16 h-16 bg-brand-yellow rounded-industrial flex items-center justify-center mx-auto mb-4" data-id="element-288">
                  <Icon className="w-8 h-8 text-dark-bg" data-id="element-289" />
                </div>
                <h3 className="text-lg font-bold text-white mb-2" data-id="element-290">
                  {reason.title}
                </h3>
                <p className="text-sm text-gray-400 leading-relaxed" data-id="element-291">
                  {reason.description}
                </p>
              </div>;
        })}
        </div>
      </div>
    </section>;
}